"use client";
import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { HeroSection } from "../components/heroComponent/HeroSection";
import PricingSection from "../components/pricingComponent/PricingSection";
import { StatsSection } from "../components/statsComponent/StatsSection";
import { ReviewsSection } from "../components/reviewsComponent/reviewsSection";
import MapInfo from "../components/contactsCompact/MappInfo";
import WhatsAppWidget from "../components/WhatsWidget";
import OurSpacesSection from "../components/SpacesSection/OurSpacesSection";

export default function Home() {
  // Scroll progress
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <div className="bg-white min-h-screen">
      {/* Barra di progresso scroll */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-600 to-green-500 transform-gpu z-[60]"
        style={{ scaleX }}
        initial={{ transformOrigin: "0%" }}
      />

      {/* Hero Section */}
      <HeroSection />

      {/* Contenuto principale */}
      <main className="relative z-10">
        <OurSpacesSection />
        <PricingSection />
        <ReviewsSection />
        <StatsSection />
        <MapInfo />
        <WhatsAppWidget />
      </main>
    </div>
  );
}
